export default __webpack_public_path__ + "static/media/incoming-call.f7b70a29.wav";